


















































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import moment, {Moment} from "moment";
import 'moment/locale/fr';
import {ReservationCardConfig} from "@/types/ReservationCardConfig";

@Component
export default class CalendarFilter extends Vue {

  public dates = [];
  public days = this.getDaysOfTheWeek();
  public today: Moment = moment().startOf('day');
  public dateContext: Moment = moment().startOf('month').startOf('day');
  public selectedDate: Moment | null = null;
  public dateIsValid: boolean = true;

  @Prop({
    type: String,
    default: 'calendarId',
  })
  public calendarId!: string;

  @Prop({
    type: Array,
    default: [],
  })
  public reservationList!: ReservationCardConfig[];

  mounted() {
    moment.locale('fr');
  };

  get year() {
    return this.dateContext.format('Y');
  };

  get month() {
    return this.dateContext.format('MMMM');
  };

  public checkDateInput() {
    if (this.selectedDate) {
      this.checkDate(this.selectedDate);
      this.closeDate();
    }
  };

  public checkDate(dateMoment: any) {
    if (!dateMoment) {
      return;
    }
    this.dateIsValid = !this.isDisabledDate(dateMoment);
  };

  public isDisabledDate(momentDate: any): boolean {
    return !this.reservationList.includes(momentDate.format('D MMMM YYYY'));
  }

  get displayDate() {
    let date = this.selectedDate;
    if (!date) return '';

    return date.format('LL');
  };

  public isDisabledDay(day: number) {
    const thisDate = this.getDateFromDay(day);
    return this.isDisabledDate(thisDate);
  };

  public backToCurrentMonth () {
    this.dateContext = moment();
  }

  get currentMonth() {
    return this.month.toString()[0].toUpperCase() + this.month.toString().slice(1) + ' ' + this.year.toString();
  };

  get daysInMonth() {
    return this.dateContext.daysInMonth();
  };

  get firstDayOfMonth() {
    let firstDay = this.dateContext.startOf('month').clone();
    return firstDay.weekday();
  };

  get previousMonth() {
    return this.dateContext.clone().subtract(1, 'month').endOf('month');
  };

  get nextMonth() {
    return this.dateContext.clone().add(1, 'month').startOf('month');
  };

  public getDaysOfTheWeek(): string[] {
    const days = [];
    for (let i = 0; i < 7; i++) {
      days.push(moment().weekday(i).format('dd')[0].toUpperCase());
    }
    return days;
  }

  public addMonth() {
    this.dateContext = this.nextMonth;
    this.$emit('add-month');
  };

  public closeDate() {
    this.$emit('date-close', this.selectedDate);
  };

  public subtractMonth() {
    this.dateContext = this.previousMonth;
    this.$emit('substract-month');
  };

  public selectDate(day: number) {
    if (this.isDisabledDay(day)) return;
    this.selectedDate = moment(this.getDateFromDay(day)).startOf('days');
    this.closeDate();
  };

  public getDateFromDay(day: number) {
    return moment().year(this.dateContext.year()).month(this.dateContext.month()).date(day);
  };

  public isSelectedDate(day: number): boolean {
    if (!this.selectedDate) return false;
    return this.selectedDate.format("LL") === this.getDateFromDay(day).format("LL");
  };

  public getDateClasses(day: number) {
    return {
      'isToday': this.today.format("LL") === this.getDateFromDay(day).format("LL"),
      'isSelected': this.isSelectedDate(day),
      'isDisabled': this.isDisabledDay(day)
    };
  }
}

